// extracted by mini-css-extract-plugin
module.exports = {"wysiwigWrapper":"wysiwyg_wysiwigWrapper__xT7QK","textStyles":"wysiwyg_textStyles__OkuKE"};